import { Type } from 'class-transformer';
import { WorkflowItemResultDto } from './workflow-item-result-dto';

export class WorkflowDetailsResultDto {
    workflowId: number;
    status: string;
    communityId: number;
    communityName: string;
    entityUsesSubCategory: boolean;
    apBillId: number;
    payee: string;
    payeeType: string;
    payeeCode: string;

    @Type(() => Date)
    invoiceDate: Date;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    postDate: Date;

    description: string;
    invoiceAmount: number;
    amount: number;
    invoiceNumber: string;
    specialHandling: string;
    lateFee: number;
    isEFTAccount: boolean;
    bankAccount: string;

    @Type(() => WorkflowItemResultDto)
    items: Array<WorkflowItemResultDto>;

    paymentStatus: string;
    invoiceStatus: string;
    vendorAccountId: number;
    vendorAccountNumber: string;
    boardApproval: boolean;

    @Type(() => Date)
    closedBookPeriodDate: Date;

    hasVendorNotes: boolean;
    hasVendorInstruction: boolean;
    managementCompanyVendorId: number;
    hasVendorWFCheckList: boolean;
    hasNotes: boolean;
    hasBoardNotes: boolean;
    specialInstruction: string;

    allowReclassify: boolean;
    managementCompanyId: number;
}
